import React from 'react';
import { Box, Text, AnchorText } from '@components/common';

function Footer() {
  return (
    <Box
      height={64}
      flexDirection="column"
      display="flex"
      justifyContent="center"
      alignItems="center"
    >
      <Box
        flexDirection="row"
        display="flex"
        justifyContent="center"
        alignItems="center"
      >
        <AnchorText mx={4} href="https://theminte.com">
          Minte
        </AnchorText>
        <AnchorText
          mx={4}
          href="https://theminte.com/terms-of-service/"
          target="_blank"
        >
          Terms
        </AnchorText>
        <AnchorText
          mx={4}
          href="https://theminte.com/privacy-policy/"
          target="_blank"
        >
          Policy
        </AnchorText>
      </Box>
      <Text textAlign="center">
        © 2019 Mint Apartment Cleaning, all rights reserved.
      </Text>
    </Box>
  );
}

export default Footer;
